
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import TopBar from '../../Components/TopBar/TopBar';
import styles from './drillDown.module.css';
import commonStyle from "../common.module.css";
import CustomTable from '../../Components/CustomTable/CustomTable';
import { getDataFromRoute } from '../../Services/contacts';
import { connect, useDispatch } from 'react-redux';
import {
  setClearFilter,
  showSnackbarAction,
  setFilterObject,
  setRefreshContacts,
} from '../../Redux/actions';
import axios from 'axios';
import Cookies from 'universal-cookie';
import moment from 'moment';
import { url } from '../../Values/constants';
import {
  CONTACT_COLUMNS,
  ContactColumns,
  datesField,
  booleanObject,
} from '../../Values/tables';
import Firebase from 'firebase/app';
import ApiTopBar from '../../Components/TopBar/ApiTopBar';
import ApiCustomTable from '../../Components/CustomTable/ApiCustomTable';
import Loading from '../../Components/Loading/Loading';
import { fetchOrganizationsUsers } from "../../Services/users";
import { themeColors } from "../../Components/theme";
import { getDateString } from '../../Values/utils';
import { useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from 'react-router-dom';

type props = {
  history: any;
  user: any;
  searchString: string;
  filterSort: any;
  filterObject: any;
  role: string;
  organizationUsers: any[];
  refreshContacts: any;
  organizationId: string;
  theme: any;
  conatctHeader: any;
  authToken: any;
};

type LocationState = {
  drilldownData?: any;
  ts?: number;
};


let usersList: any[] = [];
let isFinished = false;
const ApiDrilldownPanel: FunctionComponent<props> = ({
  history,
  user,
  searchString,
  filterSort,
  filterObject,
  role,
  organizationUsers,
  refreshContacts,
  organizationId,
  theme,
  conatctHeader,
  authToken
}) => {
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const location = useLocation<LocationState>();
  const [searchedItem, setsearchedItem] = useState('');
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [lastPage, setLastPage] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [load, setLoad] = useState(false);
  const [allLeads, setAllLeads] = useState(false);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [userMap, setUserMap] = useState<any>(undefined);
  const [drillDownCount, SetDrillDownCount] = useState<any>({});
  const [localStorageData, setLocalStorageData] = useState<any>({});
  const [uid, setuid] = useState<any>({});
  const [filterApiCount, SetFilterApiCount] = useState<any>({});
  const [drillRole, setDrillRole] = useState<any>({});
  const [userBranchMap, setBranchMap] = useState<any>(undefined);
  const [userTeamMap, setTeamMap] = useState<any>(undefined);
  const [clearFilterTable, setClearFilterTable] = useState(false);
  const dispatcher = useDispatch();
  const cookies = new Cookies();

  const memoColumns = useMemo(() => {
    return ContactColumns(conatctHeader);
  }, [conatctHeader]);

  let userId = cookies.get("uId");
  const createUsersList = (email: string, users: any[], uid: boolean) => {
    users.map((item: any) => {
      if (usersList.includes(item)) {
        return;
      } else {
        if (item.reporting_to === email && item.status === 'ACTIVE') {
          if (!usersList.includes(item)) {
            usersList.push(item);
          }

          createUsersList(item.user_email, users, uid);
        }
      }
    });
  };

  useEffect(() => {
    if (localStorageData.organizationid) {
      const unSub = fetchOrganizationsUsers(
        dispatcher,
        localStorageData.organizationid
      );
      return () => {
        unSub();
      };
    }
  }, [localStorageData, dispatcher]);

  useEffect(() => {
    if (organizationUsers) {
      let uids: { [key: string]: string } = {};
      let uidsBranch: { [key: string]: string } = {};
      let uidsTeam: { [key: string]: string } = {};
      organizationUsers.forEach((user: any) => {
        uids[user.user_email] = user.reporting_to;
        uidsBranch[user.user_email] = user.branch;
        uidsTeam[user.user_email] = user.team;
      });
      setBranchMap(uidsBranch)
      setUserMap(uids);
      setTeamMap(uidsTeam)
    }
  }, [organizationUsers]);

  useEffect(() => {
    // 1️⃣ FIRST PRIORITY → location.state
    if (location.state?.drilldownData) {
      setLocalStorageData(location.state.drilldownData);

      // keep backup
      localStorage.setItem(
        'drilldownData',
        JSON.stringify(location.state.drilldownData)
      );
      return;
    }

    // 2️⃣ FALLBACK → localStorage (page refresh case)
    const saved = localStorage.getItem('drilldownData');
    if (saved) {
      setLocalStorageData(JSON.parse(saved));
    }
  }, [location.state?.ts]);


  const callApi = async (
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number
  ) => {
    if (isFinished === true) {
      return;
    }
    else {
      setLoad(true);
      const filters: { [key: string]: any[] } = { ...localStorageData.leadFilter };

      if (localStorageData.source === true) {
        filters['source_status'] = ['True'];
      }
      else {
        filters['associate_status'] = ['True'];
      }
      setDrillRole(localStorageData.role);
      let feild;

      Object.keys(filterObject).forEach((item) => {
        if (filterObject && filterObject[item].length > 0) {
          filters[item] = filterObject[item];
        }
      });
      if (searchString === '') {
        feild = 'contact_no';
      } else {
        if (searchString.match(/^[0-9]+$/) != null) {
          feild = 'contact_no';
        } else {
          feild = 'customer_name';
        }
      }
      const { reporting_to, team, branch, ...objLeadUserFilterValues } = filters;

      let records = localPageSize ? localPageSize : pageSize;
      const apiData = {
        uid: localStorageData.source === true && localStorageData.role === false ? userId : localStorageData.uid,
        organizationid: localStorageData.organizationid,
        page: localPage ? localPage : page + 1,
        searchString: searchString,
        sort:
          Object.keys(filterSort).length === 0
            ? { created_at: '-1' }
            : filterSort,
        pageSize: localPageSize ? localPageSize : pageSize,
        taskFilter: localStorageData.taskFilter,
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        leadFilter: localStorageData.source === true && localStorageData.role === false ? { ...objLeadUserFilterValues, "lead_source": [localStorageData.uid] } : objLeadUserFilterValues,
        role: localStorageData.source === true && localStorageData.role === false ? true : localStorageData.role,

      };
      SetDrillDownCount(filters);
      SetFilterApiCount(apiData)
      try {
        axios.defaults.headers.common['x-access-token'] =
          authToken
        const res = await axios.post(url + '/leads/drillDownSearch', apiData);
        let data: any[] = res.data;
        const recordsNum = typeof records === "number" ? records : Number(records);

        // -------- Pagination End Detection --------
        if (data.length < recordsNum && paginate) {
          isFinished = true;
          setLastPage(page);
        }
        data.forEach((lead) => {
          lead.contactId = lead.Id;
          lead["reporting_to"] = userMap[lead.contact_owner_email];
          lead["branch"] = userBranchMap[lead.contact_owner_email];
          lead["team"] = userTeamMap[lead.contact_owner_email];
          delete lead['Id'];
          Object.keys(lead).forEach((key) => {
            if (datesField.includes(key) && lead[key] !== '') {
              if (lead[key] !== null) {
                lead[key] = Firebase.firestore.Timestamp.fromDate(
                  moment(lead[key]).toDate()
                );
              } else {
                lead[key] = '';
              }
            }
          });
        });
        if (paginate && filterData) {
          let newData = [...filterData, ...data];
          setFilterData(newData);
        } else {
          setFilterData(data);
        }
        setLoad(false);
      } catch (error) {
        setFilterData([]);
        setLoad(false);
        // dispatcher(showSnackbarAction('Please Try Again!!', 'error'));
      }
    }
  };

  useEffect(() => {
    if (localStorageData.uid === undefined) {
      setFilterData([]);
      return;
    }
    if (userMap === undefined) {
      setFilterData([]);
      return;
    }
    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if (authToken) {
      callApi(false, pageSize, 1);
    }
  }, [allLeads, filterObject, userMap, localStorageData, authToken]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if (authToken) {
          callApi(false, pageSize);
        }
      } else {
        if (authToken) {
          callApi(true, pageSize);
        }
      }
    }
  }, [page, pageSize, authToken]);

  useEffect(() => {
    if (localStorageData.uid === undefined) {
      setFilterData([]);
      return;
    }
    if (authToken) {
      callCountApi();
    }
  }, [refreshContacts, localStorageData.uid, drillDownCount, filterApiCount, authToken]);

  const callCountApi = async () => {
    const filterValues: { [key: string]: any[] } = {};
    Object.keys(drillDownCount).forEach((item) => {
      if (drillDownCount && drillDownCount[item].length > 0) {
        if (item === "is_button_called" || item === "transfer_status" || item === "associate_status" || item === "source_status") {
          if (drillDownCount[item].length === 2) {
            filterValues[item] = [true, false];
          } else {
            if (item === "transfer_status") {
              filterValues[item] = drillDownCount[item];
            } else {
              filterValues[item] =
                drillDownCount[item][0] === "True" ? [true] : [false];
            }
          }
        }
        else filterValues[item] = drillDownCount[item];
      }
    });
    const { reporting_to, team, branch, ...objLeadFilterDrillDownCount } = filterValues;
    if (drillRole === true) {
      axios.defaults.headers.common['x-access-token'] =
        authToken
      const res = await axios.post(url + '/leads/contacttotalcount', {
        uid: localStorageData.uid,
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        leadFilter: objLeadFilterDrillDownCount,
        taskFilter: localStorageData.taskFilter
      });
      setTotalCounts(res.data.total);
    }
    else {
      const uId = localStorageData.uid
      axios.defaults.headers.common['x-access-token'] =
        authToken
      const res = await axios.post(url + '/leads/contacttotalcount', {
        uid: localStorageData.source === true && localStorageData.role === false ? userId : uId,
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        leadFilter: localStorageData.source === true && localStorageData.role === false ? { ...objLeadFilterDrillDownCount, "lead_source": [uId] } : { ...objLeadFilterDrillDownCount, "uid": [uId] },
        taskFilter: localStorageData.taskFilter
      });
      setTotalCounts(res.data.total);
    }
  };

  useEffect(() => {
    if (refreshContacts === true) {
      if (authToken) {
        callApi();
        getContactsFilter();
        dispatcher(setRefreshContacts(false));
      }
    }
  }, [refreshContacts, authToken]);

  const getContactsFilter = async () => {
    const uId = localStorageData.uid
    axios.defaults.headers.common['x-access-token'] =
      authToken
    const res = await axios.post(url + '/leads/filterValues', {
      uid: localStorageData.source === true && localStorageData.role === false ? userId : uId
    });

    if (res.data[0]) {
      dispatcher(setFilterObject({ ...res.data[0], ...booleanObject }));
    } else {
      dispatcher(setFilterObject({}));
    }
  };

  useEffect(() => {
    if (localStorageData.uid === undefined) {
      return;
    }
    if (authToken) {
      getContactsFilter();
    }
  }, [localStorageData.uid, authToken]);

  const setUsersList = () => {
    if (role === 'Lead Manager') {
      organizationUsers.map((item: any) => {
        if (usersList.includes(item)) {
          return;
        } else {
          if (item.status === 'ACTIVE') {
            usersList.push(item);
          }
        }
      });
    } else {
      createUsersList(user.user_email, organizationUsers, false);
    }
  };

  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };

  const exportFile = () => {
    let data: any[] = [];
    interface DataObj {
      label: any;
      value: any;
    }
    // const dbData = [{"label": "customer_name","value": "Customer Name"},{"label": "country_code","value": "Country Code"},{"label": "contact_no","value": "Mobile No."},{"label": "alternate_no","value": "Alternate No."},{"label": "email","value": "Email Id"},{"label": "stage","value": "Stage"},{"label": "contact_owner_email","value": "Owner"},{"label": "lead_source","value": "Lead Source"},{"label": "budget","value": "Budget"},{"label": "call_back_reason","value": "Call back reason"},{"label": "project","value": "Project"},{"label": "property_type","value": "Property type"},{"label": "property_sub_type","value": "Property Sub Type"},{"label": "property_stage","value": "Property Stage"},{"label": "location","value": "Location"},{"label": "lost_reason","value": "Lost reason"},{"label": "not_int_reason","value": "Not Interested Reason"},{"label": "other_lost_reason","value": "Other Lost Reason"},{"label": "other_not_int_reason","value": "Other Not interested reason"},{"label": "next_follow_up_type","value": "Next follow up type"},{"label": "next_follow_up_date_time","value": "Next follow up date and time"},{"label": "created_by","value": "Created By"},{"label": "created_at","value": "Created At"},{"label": "lead_assign_at","value": "Lead Assign At"},{"label": "stage_change_at","value": "Stage Change At"},{"label": "addset","value": "Addset"},{"label": "campaign","value": "Campaign"},{"label": "inventory_type","value": "Inventory Type"},{"label": "notes","value": "Notes"},{"label": "lead_type","value": "Lead Type"},{"label": "previous_owner_1","value": "Previous Owner 1"},{"label": "previous_owner_2","value": "Previous Owner 2"},{"label": "reporting_to","value": "Reporting To"},{"label": "transfer_by_1","value": "Transfer By 1"},{"label": "previous_owner","value": "Previous Owner"},{"label": "transfer_status","value": "Transfer Status"},{"label": "associate_status","value": "Associate Status"},{"label": "source_status","value": "Source Status"},{"label": "transfer_by_2","value": "Transfer By 2"},{"label": "previous_stage_1","value": "Previous Stage 1"},{"label": "previous_stage_2","value": "Previous Stage 2"},{"label": "transfer_reason","value": "Transfer Reason"},{"label": "modified_at","value": "Modified At"},{"label": "lead_assign_time","value": "Lead Assign Time"},{"label": "is_button_called","value": "Is Button Called"},{"label": "feedback_time","value": "Feedback Time"},{"label": "branch","value": "Branch"},{"label": "team","value": "Team"}];
    const dbData = conatctHeader;
    const drillHeaderCustomerName: any = dbData.find((obj: DataObj) => obj.label === "customer_name")?.value;
    const drillHeaderCountryCode: any = dbData.find((obj: DataObj) => obj.label === "country_code")?.value;
    const drillHeaderMobileNo: any = dbData.find((obj: DataObj) => obj.label === "contact_no")?.value;
    const drillHeaderAlternateNo: any = dbData.find((obj: DataObj) => obj.label === "alternate_no")?.value;
    const drillHeaderLeadSource: any = dbData.find((obj: DataObj) => obj.label === "lead_source")?.value;
    const drillHeaderCreatedAt: any = dbData.find((obj: DataObj) => obj.label === "created_at")?.value;
    const drillHeaderContactOwnerEmail: any = dbData.find((obj: DataObj) => obj.label === "contact_owner_email")?.value;
    const drillHeaderEmailId: any = dbData.find((obj: DataObj) => obj.label === "email")?.value;
    const drillHeaderStage: any = dbData.find((obj: DataObj) => obj.label === "stage")?.value;
    const drillHeaderCallBackReason: any = dbData.find((obj: DataObj) => obj.label === "call_back_reason")?.value;
    const drillHeaderPropertyStage: any = dbData.find((obj: DataObj) => obj.label === "property_stage")?.value;
    const drillHeaderPropertyType: any = dbData.find((obj: DataObj) => obj.label === "property_type")?.value;
    const drillHeaderPropertySubType: any = dbData.find((obj: DataObj) => obj.label === "property_sub_type")?.value;
    const drillHeaderLocation: any = dbData.find((obj: DataObj) => obj.label === "location")?.value;
    const drillHeaderProject: any = dbData.find((obj: DataObj) => obj.label === "project")?.value;
    const drillHeaderBudget: any = dbData.find((obj: DataObj) => obj.label === "budget")?.value;
    // const drillHeaderInventoryType :any = dbData.find((obj: DataObj) => obj.label === "inventory_type")?.value;
    const drillHeaderCampaign: any = dbData.find((obj: DataObj) => obj.label === "campaign")?.value;
    const drillHeaderAddset: any = dbData.find((obj: DataObj) => obj.label === "addset")?.value;
    const drillHeaderNotInterestedReason: any = dbData.find((obj: DataObj) => obj.label === "not_int_reason")?.value;
    const drillHeaderLostReason: any = dbData.find((obj: DataObj) => obj.label === "lost_reason")?.value;
    const drillHeaderOtherNotinterestedreason: any = dbData.find((obj: DataObj) => obj.label === "other_not_int_reason")?.value;
    const drillHeaderOtherLostReason: any = dbData.find((obj: DataObj) => obj.label === "other_lost_reason")?.value;
    const drillHeaderNextfollowuptype: any = dbData.find((obj: DataObj) => obj.label === "next_follow_up_type")?.value;
    const drillHeaderNextfollowupdateandtime: any = dbData.find((obj: DataObj) => obj.label === "next_follow_up_date_time")?.value;
    const drillHeaderCreatedBy: any = dbData.find((obj: DataObj) => obj.label === "created_by")?.value;
    const drillHeaderStageChangeAt: any = dbData.find((obj: DataObj) => obj.label === "stage_change_at")?.value;
    const drillHeaderLeadType: any = dbData.find((obj: DataObj) => obj.label === "lead_type")?.value;
    const drillHeaderPreviousOwner1: any = dbData.find((obj: DataObj) => obj.label === "previous_owner_1")?.value;
    const drillHeaderPreviousOwner2: any = dbData.find((obj: DataObj) => obj.label === "previous_owner_2")?.value;
    const drillHeaderReportingTo: any = dbData.find((obj: DataObj) => obj.label === "reporting_to")?.value;
    const drillHeaderTransferBy1: any = dbData.find((obj: DataObj) => obj.label === "transfer_by_1")?.value;
    const drillHeaderPreviousOwner: any = dbData.find((obj: DataObj) => obj.label === "previous_owner")?.value;
    const drillHeaderTransferStatus: any = dbData.find((obj: DataObj) => obj.label === "transfer_status")?.value;
    const drillHeaderAssociateStatus: any = dbData.find((obj: DataObj) => obj.label === "associate_status")?.value;
    const drillHeaderSourceStatus: any = dbData.find((obj: DataObj) => obj.label === "source_status")?.value;
    const drillHeaderTransferBy2: any = dbData.find((obj: DataObj) => obj.label === "transfer_by_2")?.value;
    const drillHeaderPreviousStage1: any = dbData.find((obj: DataObj) => obj.label === "previous_stage_1")?.value;
    const drillHeaderPreviousStage2: any = dbData.find((obj: DataObj) => obj.label === "previous_stage_2")?.value;
    const drillHeaderTransferReason: any = dbData.find((obj: DataObj) => obj.label === "transfer_reason")?.value;
    const drillHeaderModifiedAt: any = dbData.find((obj: DataObj) => obj.label === "modified_at")?.value;
    const drillHeaderLeadAssignTime: any = dbData.find((obj: DataObj) => obj.label === "lead_assign_time")?.value;
    const drillHeaderIsButtonCalled: any = dbData.find((obj: DataObj) => obj.label === "is_button_called")?.value;
    const drillHeaderFeedbackTime: any = dbData.find((obj: DataObj) => obj.label === "feedback_time")?.value;
    const drillHeaderBranch: any = dbData.find((obj: DataObj) => obj.label === "branch")?.value;
    const drillHeaderTeam: any = dbData.find((obj: DataObj) => obj.label === "team")?.value;
    if (selectedRowsData.length !== 0) {
      selectedRowsData.forEach((item, index) => {
        data.push({
          "S.NO": index + 1,
          [drillHeaderCustomerName]: item?.customer_name,
          [drillHeaderCountryCode]: item?.country_code,
          [drillHeaderMobileNo]: item?.contact_no,
          [drillHeaderAlternateNo]: item?.alternate_no,
          [drillHeaderLeadSource]: item?.lead_source,
          // "Created At": item?.created_at?.toDate(),
          [drillHeaderCreatedAt]: getDateString(item?.created_at),
          [drillHeaderPreviousOwner1]: item?.previous_owner_1,
          [drillHeaderContactOwnerEmail]: item?.contact_owner_email,
          [drillHeaderEmailId]: item?.email,
          [drillHeaderPreviousOwner2]: item?.previous_owner_2,
          [drillHeaderStage]: item?.stage,
          [drillHeaderReportingTo]: item?.reporting_to,
          [drillHeaderTransferBy1]: item?.transfer_by_1,
          [drillHeaderCallBackReason]: item?.call_back_reason,
          [drillHeaderPropertyStage]: item?.property_stage,
          [drillHeaderPropertyType]: item?.property_type,
          [drillHeaderPropertySubType]: item?.property_sub_type,
          [drillHeaderLocation]: item?.location,
          [drillHeaderProject]: item?.project,
          [drillHeaderBudget]: item?.budget,
          // [drillHeaderInventoryType]: item?.inventory_type,
          [drillHeaderCampaign]: item?.campaign,
          [drillHeaderAddset]: item?.addset,
          [drillHeaderNotInterestedReason]: item?.not_int_reason,
          [drillHeaderLostReason]: item?.lost_reason,
          [drillHeaderOtherNotinterestedreason]: item?.other_not_int_reason,
          [drillHeaderOtherLostReason]: item?.other_lost_reason,
          [drillHeaderPreviousOwner]: item?.previous_owner,
          [drillHeaderTransferStatus]: item?.transfer_status,
          [drillHeaderAssociateStatus]: item?.associate_status,
          [drillHeaderSourceStatus]: item?.source_status,
          [drillHeaderTransferBy2]: item?.transfer_by_2,
          [drillHeaderNextfollowupdateandtime]: getDateString(item?.next_follow_up_date_time),
          [drillHeaderNextfollowuptype]: item?.next_follow_up_type,
          [drillHeaderCreatedBy]: item?.created_by,
          [drillHeaderPreviousStage1]: item?.previous_stage_1,
          [drillHeaderPreviousStage2]: item?.previous_stage_2,
          [drillHeaderTransferReason]: item?.transfer_reason,
          [drillHeaderModifiedAt]: getDateString(item?.modified_at),
          [drillHeaderStageChangeAt]: getDateString(item?.stage_change_at),
          [drillHeaderLeadAssignTime]: getDateString(item?.lead_assign_time),
          [drillHeaderIsButtonCalled]: item?.is_button_called,
          [drillHeaderFeedbackTime]: getDateString(item?.feedback_time),
          [drillHeaderBranch]: item?.branch,
          [drillHeaderTeam]: item?.team,
          [drillHeaderLeadType]: item?.lead_type,
        });
      });
    }
    return data;
  };

  const topBarStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, width: "97%" }
  const parentStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark }
  return (
    <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...parentStyles }}>
      <div className={commonStyle.topBar} style={{ marginTop: "0px", ...topBarStyles }}>
        {load === true && <Loading />}

        <ApiTopBar
          history={history}
          title={'drilldown'}
          path={'/drilldownData'}
          changeOwner={() => {
            setUsersList();
          }}
          onChange={(val) => setsearchedItem(val)}
          filterText={'Status'}
          setColumnModal={(data) => setColumnModal(data)}
          show={true}
          showStatusBox={true}
          searchedString={searchString}
          setAllLeads={(data) => setAllLeads(data)}
          onExport={exportFile}
          titleDrillDown={'Drill Down'}
          clearFilter={handleClearFilter}
        />
      </div>
      <div className={commonStyle.parent} style={{ minHeight: "450px" }}>
        <ApiCustomTable
          tableColumns={memoColumns}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="User"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setPage={(val) => setPage(val)}
          setPageSize={(val) => setPageSize(val)}
          callApi={callApi}
          pageSize={pageSize}
          page={page}
          isFinished={isFinished}
          totalCount={totalCounts}
          lastPage={lastPage}
          clearFilterTable={clearFilterTable}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    filterSort: state.filterSort,
    refreshContacts: state.refresh.refreshContacts,
    searchString: state.searchItem.contactsSearchString,
    filterObject: state.filter,
    organizationUsers: state.organizationUsers.data,
    organizationId: state.organization.id,
    theme: state.theme.isLightMode,
    conatctHeader: state.contactHeaderList.data,
    authToken: state.user.authToken
  };
};
export default connect(mapStateToProps)(ApiDrilldownPanel);
